import classNames from 'classnames';
import React from 'react';
import SVGIcon from '../../components/SVGIcon';
import annotationIcon from '../../icons/non-prefilled/16x16/annotation.svg';
import * as styles from './AnnotationIcon.module.scss';

type AnnotationIconProps =
  | {
      size: 'small';
    }
  | {
      size?: 'regular';
      hoverable?: boolean;
    };

const AnnotationIcon = (props: AnnotationIconProps) => {
  const icon = <SVGIcon className={styles.icon}>{annotationIcon}</SVGIcon>;
  if (props.size === 'small') return icon;

  return (
    <div
      className={classNames(styles.container, {
        [styles.hoverable]: props.hoverable,
      })}
    >
      {icon}
    </div>
  );
};

export default AnnotationIcon;
